import { Link } from "react-router-dom";
import { HealthBar } from "../HealthBar/HealthBar.js";
import type { Project } from "../../lib/types.js";
import styles from "./ProjectCard.module.css";

interface ProjectCardProps {
  project: Project;
}

function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function ProjectCard({ project }: ProjectCardProps) {
  const run = project.latestRun;
  const score = run?.summary?.score ?? 0;

  return (
    <Link to={`/projects/${project.id}`} className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.name}>{project.name}</h3>
        <span className={styles.profileBadge}>{project.profileSlug}</span>
      </div>
      <p className={styles.url}>{project.urlBase}</p>
      <div className={styles.health}>
        <HealthBar score={score} />
      </div>
      <div className={styles.footer}>
        <span className={styles.passRate}>{score}% pass</span>
        {run && (
          <span className={styles.lastRun}>
            {formatRelativeTime(run.startedAt)}
            <span
              className={styles.statusDot}
              data-status={run.status}
              aria-label={run.status}
            />
          </span>
        )}
      </div>
    </Link>
  );
}
